import api from "../api";

export default {
    index() {
        return api.get('/merchant/teams')
    },

    store() {
        return api.post('/merchant/teams')
    }
}